import productNameTypes from 'helpers/enums/productNameTypes'

import userGraySVG from 'assets/views/navigation_menu/main/badges/user_gray_icon.svg'
import userGoldSVG from 'assets/views/navigation_menu/main/badges/user_yellow_icon.svg'
import userGreenSVG from 'assets/views/navigation_menu/main/badges/user_green_icon.svg'
import adminGreenSvg from 'assets/views/navigation_menu/main/badges/admin_green_icon.svg'
import adminRedSvg from 'assets/views/navigation_menu/main/badges/admin_red_icon.svg'
import userIcebergSvg from 'assets/views/navigation_menu/main/badges/user_blue_icon.svg'


export default productNameType => {
	if (!productNameType) {
		return userGraySVG
	}
	const ICONS = {
		[productNameTypes.SILVER]: userGraySVG,
		[productNameTypes.GOLD]: userGoldSVG,
		[productNameTypes.CART]: userGreenSVG,
		[productNameTypes.SCHOOL]: adminGreenSvg,
		[productNameTypes.DISTRICT]: adminRedSvg,
		[productNameTypes.PLATINUM]: userIcebergSvg,
	}
	return ICONS[productNameType]
}
